/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import PositionRole from "components/employeeRoles/PositionRole";
import Pagination from "react-js-pagination";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import { Trans } from "react-i18next";
import i18next from "i18next";
import Helpers from "util/helpers";

class PositionRoles extends Component {
  state = {
    filteredRolesData: [],
    filterTerm: "",
    error: null,
    activePage: 1,
    dataFetched: false,
    sort_by: "trPosition",
    sort_dir: "desc",
  };

  settings = {
    itemsPerPage: 10,
  };

  componentDidMount() {
    this.setState({ filteredRolesData: this.props.data.positionRoles });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.setState({ filteredRolesData: this.props.data.positionRoles });
    }

    if (this.state.filterTerm !== prevState.filterTerm) {
      this.setState({
        filteredRolesData: this.props.data.positionRoles.filter((item) => {
          return (
            Helpers.getTurkishCharaterFixedList(item.position.name).includes(
              Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
            ) ||
            Helpers.getTurkishCharaterFixedList(item.role.name).includes(
              Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
            ) ||
            Helpers.getTurkishCharaterFixedList(item.training.name).includes(
              Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
            )
          );
        }),
        activePage: 1
      });
    }
  }

  handlePageChange = (pageNum) => {
    this.setState({ activePage: pageNum });
  };

  handleFilter = (e) => {
    this.setState({ filterTerm: e.target.value });
  };

  renderSearchBar = () => {
    return (
      <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 tableSearchArea">
        <div className="inner-addon right-addon">
          <span className="iconmford fo-icon-search"></span>
          <input
            type="text"
            name="tableSearch"
            id="tableSearch"
            className="form-control"
            placeholder={i18next.t("10053")}
            onChange={(e) => this.handleFilter(e)}
            value={this.state.filterTerm}
          />
        </div>
      </div>
    );
  };

  renderHeaderToolbar = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginRight: "20px",
          marginLeft: "20px",
        }}
      >
        {this.renderSearchBar()}

        <Pagination
          hideFirstLastPages={true}
          prevPageText={i18next.t(10110)}
          nextPageText={i18next.t(10111)}
          hideDisabled={true}
          hideNavigation={true}
          activePage={this.state.activePage}
          itemsCountPerPage={this.settings.itemsPerPage}
          totalItemsCount={
            this.state.filteredRolesData?.length > 0
              ? this.state.filteredRolesData.length
              : 0
          }
          onChange={(e) => this.handlePageChange(e)}
          itemClass="page-item"
          linkClass="page-link"
        />
      </div>
    );
  };

  renderFooterToolbar = () => {
    return (
      <div className="table-footer-toolbar">
        {/* <button className="export-button" onClick={this.handleExportCSV}>
          <Trans desc="Dışa Aktar">10113</Trans>
        </button> */}
      </div>
    );
  };

  trPosition = "";
  trRole = "";
  trTraining = "";
  trQualification = "";
  trFormattedMethod = "";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.trPosition = "";
    this.trRole = "";
    this.trTraining = "";
    this.trQualification = "";
    this.trFormattedMethod = "";

    switch (this.state.sort_by) {
      case "trPosition":
        this.trPosition = `_${this.state.sort_dir}`;
        break;
      case "trRole":
        this.trRole = `_${this.state.sort_dir}`;
        break;
      case "trTraining":
        this.trTraining = `_${this.state.sort_dir}`;
        break;
      case "trQualification":
        this.trQualification = `_${this.state.sort_dir}`;
        break;
      case "trFormattedMethod":
        this.trFormattedMethod = `_${this.state.sort_dir}`;
        break;
      default:
        this.trPosition = `_${this.state.sort_dir}`;
        break;
    }
  };

  renderData = (start, end) => {
    const sorted = this.state.filteredRolesData.sort((a, b) => {
      switch (this.state.sort_by) {
        case "trPosition":
          return this.state.sort_dir === "desc"
            ? a.position?.name.localeCompare(b.position?.name)
            : b.position?.name.localeCompare(a.position?.name);
        case "trRole":
          return this.state.sort_dir === "desc"
            ? a.role?.name.localeCompare(b.role?.name)
            : b.role?.name.localeCompare(a.role?.name);
        case "trTraining":
          return this.state.sort_dir === "desc"
            ? a.training?.name.localeCompare(b.training?.name)
            : b.training?.name.localeCompare(a.training?.name);
        case "trQualification":
          return this.state.sort_dir === "desc"
            ? (a.qualification ?? 0) - (b.qualification ?? 0)
            : (b.qualification ?? 0) - (a.qualification ?? 0);
        case "trFormattedMethod":
          return this.state.sort_dir === "desc"
            ? a.formattedMethod.localeCompare(b.formattedMethod)
            : b.formattedMethod.localeCompare(a.formattedMethod);
        default:
          return this.state.sort_dir === "desc"
            ? a.position?.name.localeCompare(b.position?.name)
            : b.position?.name.localeCompare(a.position?.name);
      }
    });

    return sorted.slice(start, end).map((role) => {
      return <PositionRole key={role.positionRoleId} role={role} />;
    });
  };

  render() {
    let start = this.settings.itemsPerPage * (this.state.activePage - 1);
    let end = start + this.settings.itemsPerPage;

    this.setSotingClassNames();

    return (
      <>
        {this.props.spinner}
        <div>{this.renderHeaderToolbar()}</div>
        <div
          className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
          id="pozisyonRolleri"
          style={{ display: "block" }}
        >
          <table
            className="table display responsive dataTable no-footer dtr-none collapsed"
            id="dataTablePersonel"
          >
            <thead>
              <tr>
                <th
                  onClick={() => this.reOrder("trPosition")}
                  className={`all sorting${this.trPosition}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Pozisyon">10593</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trRole")}
                  className={`all sorting${this.trRole}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Rol">10594</Trans>
                  </div>
                </th>
                <DesktopBreakpoint>
                  <th
                    onClick={() => this.reOrder("trTraining")}
                    className={`desktop sorting${this.trTraining}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Eğitim">10595</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trQualification")}
                    className={`desktop sorting${this.trQualification}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Yeterlilik">10596</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trFormattedMethod")}
                    className={`desktop sorting${this.trFormattedMethod}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Tür">10570</Trans>
                    </div>
                  </th>
                </DesktopBreakpoint>
              </tr>
            </thead>
            <tbody>{this.renderData(start, end)}</tbody>
          </table>
        </div>
        <div>
          <hr />
          {this.renderFooterToolbar()}
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ application }) => {
  return {
    application,
  };
};

export default connect(
  mapStateToProps,
  {}
)(containsLongRunningProcess(requireAuth(PositionRoles)));
